module.exports = __webpack_public_path__ + "img/button-start-play-on.19de7c2b.svg";